import { InjectedConnector } from "@web3-react/injected-connector";

export const injected = new InjectedConnector({
  supportedChainIds: [5, 42, 1337, 1, 11155111, 80001, 137],
});
